/** A challenge link looks like https://your-game/?c=abcd1234. */
export function challengeCodeFromUrl(search: string): string | null {
  const code = new URLSearchParams(search).get('c');
  return code && /^[a-f0-9]{8}$/.test(code) ? code : null;
}

export function challengeUrl(code: string, origin = location.origin): string {
  return `${origin}/?c=${code}`;
}

/** Removes ?c=… from the address bar once it's been read, so a refresh doesn't pop it up again. */
export function clearChallengeFromUrl(): void {
  const url = new URL(location.href);
  if (!url.searchParams.has('c')) return;
  url.searchParams.delete('c');
  history.replaceState(null, '', url.pathname + url.search + url.hash);
}
